import { Drawn, type BrandMarkProps } from "./Drawn.tsx";
import { mark } from "./generated/mark.ts";

export interface BatonMarkProps extends BrandMarkProps {
  /** Draws the sheen layer while the caller plays it (DESIGN.md § Brand: the rail's head, on hover and on keyboard focus). */
  readonly sheen?: boolean;
}

/** The B mark alone, where the room is tight. */
export function BatonMark({ sheen = false, ...props }: BatonMarkProps) {
  return <Drawn shape={mark} sheen={sheen} {...props} />;
}
